<h2 mat-dialog-title class="av-section-title">{{ data.title | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0" data-testid="reason-dialog-consequence">
    {{ data.consequence | translate }}
  </p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="reason-dialog-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.subject' | translate }}</dt>
      <dd class="m-0 text-end" data-testid="reason-dialog-subject">{{ data.subjectLabel }}</dd>
    </div>
  </dl>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="reason-dialog-input">
      <span class="av-meta">{{ 'backoffice.common.reason_dialog.reason' | translate }}</span>
      <textarea
        id="reason-dialog-input"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="reason-dialog-input"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn"
    [class.av-btn-primary]="!data.isDangerous"
    [class.av-btn-danger]="data.isDangerous"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
    data-testid="reason-dialog-submit"
  >
    {{ data.confirmLabel | translate }}
  </button>
</mat-dialog-actions>
